import { render } from "./MSuccessToast.vue?vue&type=template&id=188bcd1e"
import script from "./MSuccessToast.vue?vue&type=script&lang=js"
export * from "./MSuccessToast.vue?vue&type=script&lang=js"

import "./MSuccessToast.vue?vue&type=style&index=0&id=188bcd1e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__